import { createTheme, type CSSVariablesResolver } from '@mantine/core'

// Brand colors
export const BLUE = '#4d4dff' // rgb(77, 77, 255)
export const GREEN = '#00ff00' // neon green

export const theme = createTheme({
  fontFamily: 'Montserrat, system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
  primaryColor: 'agfGreen',
  primaryShade: { light: 7, dark: 5 },
  colors: {
    agfBlue: [
      '#e8e8ff',
      '#c4c4ff',
      '#9d9dff',
      '#7676ff',
      '#5c5cff',
      '#4d4dff',
      '#4040e6',
      '#3333cc',
      '#2626b3',
      '#1a1a99',
    ],
    agfGreen: [
      '#e6ffe6',
      '#b3ffb3',
      '#80ff80',
      '#4dff4d',
      '#1aff1a',
      '#00ff00',
      '#00e600',
      '#00cc00',
      '#00b300',
      '#009900',
    ],
    dark: [
      '#C1C2C5',
      '#A6A7AB',
      '#909296',
      '#5c5f66',
      '#373A40',
      '#2C2E33',
      '#25262b',
      '#1A1B1E',
      '#141517',
      '#101113',
    ],
  },
  components: {
    Paper: {
      defaultProps: {
        radius: 'md',
      },
    },
    Button: {
      defaultProps: {
        radius: 'md',
      },
    },
    TextInput: {
      defaultProps: {
        radius: 'md',
      },
    },
    Select: {
      defaultProps: {
        radius: 'md',
      },
    },
    Modal: {
      defaultProps: {
        radius: 'lg',
      },
    },
  },
})

export const cssVariablesResolver: CSSVariablesResolver = () => ({
  variables: {
    '--agf-blue': BLUE,
    '--agf-green': GREEN,
  },
  // LIGHT scheme - clean professional look
  light: {
    '--mantine-color-body': '#f8faf8',
    '--agf-bg-white': '#ffffff',
    '--agf-bg-gray': '#f1f3f1',
    '--agf-bg-green': 'rgba(0, 200, 0, 0.08)',
    '--agf-border': 'rgba(0, 100, 0, 0.15)',
    '--agf-text': '#1a1f1a',
    '--agf-text-muted': 'rgba(0, 0, 0, 0.6)',
    '--agf-header-bg': 'rgba(255, 255, 255, 0.95)',
    '--agf-card-bg': '#ffffff',
    '--agf-card-border': 'rgba(0, 100, 0, 0.12)',
    '--agf-accent': '#00aa00',
    '--agf-accent-text': '#007700',
  },
  // DARK scheme - glass aesthetic
  dark: {
    '--mantine-color-body': '#0a0a0f',
    '--agf-bg-white': 'rgba(0, 0, 0, 0.75)',
    '--agf-bg-gray': 'rgba(0, 0, 0, 0.5)',
    '--agf-bg-green': 'rgba(0, 255, 0, 0.1)',
    '--agf-border': 'rgba(0, 255, 0, 0.2)',
    '--agf-text': '#ffffff',
    '--agf-text-muted': 'rgba(255, 255, 255, 0.6)',
    '--agf-header-bg': 'rgba(0, 0, 0, 0.85)',
    '--agf-card-bg': 'rgba(0, 0, 0, 0.75)',
    '--agf-card-border': 'rgba(0, 255, 0, 0.2)',
    '--agf-accent': '#00ff00',
    '--agf-accent-text': '#00ff00',
  },
})
